/**
 * Class for module selector
 *
 * @class Theming
 * @depends jquery.js, controller.js
 */
var $ = require('jquery');
var siteadmin = require('../siteadmin');
var api = require('../api');
var page = require('diy/page/page');

(function() {

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null;

    /**
     * the help topics ids
     */
    var helpColors = 'style_theming_settings_colors',
        helpFonts = 'style_theming_settings_fonts',
        helpBackground = 'style_theming_settings_background';

    /**
     * reference for within callbacks
     */
    var me = this;
    this.controllerLoaded = false;

    /**
     * template for generating the minimize/maximize button
     * @param state
     * @returns {String}
     */
    this.minimizableButtonTemplate = function(state) {
        //TODO: this is sample data
        var label;
        if(state == 'minimize'){
            label = jimdoData.messages.theming.settings.button.min;
        } else {
            label = jimdoData.messages.theming.settings.button.max;
        }
        return '<div class="start-animation">' + label + '</div>';
    };

    /**
     * sends the save request to the theming angular app.
     * also includes callbacks that controll what happens on
     * start saving and success/errors when saving
     */
    this.save = function() {
        var controller = siteadmin.getController();

        var interfaceElementContainer = $(contentEl).parent('main');
        diy.editor.theming.run(function(scope) {
            scope.save({
                start: function() {
                    interfaceElementContainer.loadingBox({useOverlay: true}).show();
                },
                success: function() {
                    interfaceElementContainer.loadingBox().remove();
                    controller.clearCache('theming');
                },
                error: function() {
                    interfaceElementContainer.loadingBox().remove();
                    controller.clearCache('theming');
                }
            });
        });
    };

    this.minimizeButtonClick = function(opts) {
        api.close();
    };

    /* specific actions for module selector */
    this.afterFillContent = function (el, payload, contentElement) {

        // remember the content element internally
        contentEl = contentElement;

        // display a loading overlay until we're done
        $(contentElement).loadingBox({useOverlay: true, overlayClass: "th-loading-opaque-overlay"}).show();

        // this is called if the script loading fails
        var scriptLoadingErrorHandler = function() {
            // default it's the save error
            var strErr = jimdoData.messages.theming.errors.generic;
            // if the original payload came with additional errors, display them too;
            /*
            if (payload.errors) {
                strErr = "";
                for(var er in payload.errors) {
                    if (payload.errors.hasOwnProperty((er))) {
                        strErr += '<p>' + payload.errors[er] + '</p>';
                    }
                }
            }
            */
            // hide the loading overlay
            $(contentElement).loadingBox().remove();
            // blocking dialog explaining that a fatal error occured
            $('<div>' + strErr + '</div>').diy_dialog({
                /* Can't use diyl10n here because we don't have the angular context */
                title: jimdoData.messages.theming.errors.generic,
                modal: true,
                draggable: false,
                resizable: false,
                closeButton: true,
                zIndex: 100100
            });
            // close the window
            api.close();
            // signal problem upstream
            return false;
        };

        // things that need to be done to actually have usable window contents
        var initializeStyleContent = function() {
            // Run the angular app bootstrap code from the theming bundle
            require.ensure([], function() {
                var bootstrap = require('diy/site-admin/theming/theming.bootstrap');
                bootstrap(payload.data, payload.data.flags);
            }, THEMING_BUNDLE_NAME);

            // hide the loading overlay
            $(contentElement).loadingBox().remove();

            // add the save button only after loading, to prevent it from being clicked meanwhile
            api.updateButtons({
                primary : {
                    text : jimdoData.messages.save,
                    callback : function() {
                        me.save();
                    }
                }
            });

            // hook the window navigation tabs with appropriate actions
            api.updateNavi([
                {
                    title : jimdoData.messages.theming.settings.tab.colors,
                    active: true,
                    identifier: 'palettes',
                    callback : function(e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('palettes');
                            api.updateHelpTopic(helpColors);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }, {
                    title : jimdoData.messages.theming.settings.tab.fonts,
                    identifier: 'typography',
                    callback : function(e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('typography');
                            api.updateHelpTopic(helpFonts);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }, {
                    title: jimdoData.messages.theming.settings.tab.background,
                    identifier: 'background',
                    callback: function (e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('background');
                            api.updateHelpTopic(helpBackground);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }
            ]);

            // set various other window characteristics
            api.updateTitle(jimdoData.messages.theming.settings.header.title);
            api.updateDescr('');
            api.updateHelpTopic(helpColors);

            // trigger KPI event for loading the colors tab
            //XXX: default tab may change; move to changeTab
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'theming.palettes'
            });

            // set internal flag to tell the rest of the controller we're ready to party
            me.controllerLoaded = true;

            // announce whoever else it may concern that init is done
            $(document).trigger("diy-editor-theming-styleWindowLoaded");
        };

        // if this is the first time theming is being loaded
        if (!diy.editor.theming
            // and the payload contains a list of scripts to load
            && payload && payload.data && $.isArray(payload.data.js)
        ) {
            // load the scripts
            diy.util.scriptLoader(payload.data.js,
                // action in case of load success; delay a bit to avoid blocking UI
                function () { setTimeout(initializeStyleContent, 10); },
                // action in case of load failure
                scriptLoadingErrorHandler
            );
        }
        // no scripts to load
        else {
            // start init procedures
            setTimeout(initializeStyleContent, 10);
        }
    };

    /**
     * does this controller allows switching to another site-admin window?
     */
    this.allowSwitch = function () {
        //if theming is not ready *yet*
        //..this happens when you double click the style icon
        //..DHDIY-20483
        if (diy.editor.theming === undefined) {
            return false;
        }
        return this.controllerLoaded;
    };

    /**
     * lets this controller decide if it opens or not
     */
    this.allowOpen = function(){
        //check if any editing is opened(navigation, header, module)
        // fix bug #DHDIY-21607. didn't change isEditing to reflect this, since a module is
        // still during editing
        if (page.isEditing() && !window.Modul.getActiveModule() ) {

            $('<div/>').html(jimdoData.messages.theming.interactions.modulesOpened.message).diy_confirmationDialog({
                //zindex: needs to be above the site-admin
                zIndex: 100100,
                modal: true,
                closeButton: false,
                draggable: true,
                resizable: false,
                buttons: {okButton:{
                    text: jimdoData.messages.theming.interactions.modulesOpened.ok,
                    click: function () {
                        $(this).remove();
                        $(window).unbind('hashchange');
                        window.location.replace(window.location.pathname
                            + window.location.search
                            + '#hm:cc-sa-item-style');
                        window.location.reload();
                    }
                },cancelButton:{
                    text: jimdoData.messages.theming.interactions.modulesOpened.cancel,
                    "class": "button-cancel",
                    click: function () { $(this).remove();}
                }}
            });
            return false;
        }

        return true;
    };

    this.show = function() {
    };

    /**
     * when the editor is clicked while the Style window is opened
     */
    this.showAlertOnClickAway = function(){
        api.close();
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/theming.js
 ** module id = 753
 ** module chunks = 0
 **/